module.exports = __webpack_public_path__ + "img/ring_g_skip_1_1.4bb7281d.png";